import styled from 'styled-components'
export const Main = styled.div`

.point-gif {
    background-position: center;
    min-height: 240px;
    border-radius: 35px;
    box-shadow: 2px 2px 18px #6e6a6a;
    overflow: hidden;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    text-align: center;
    .poin-gif_container{
        width: 100%;
    }
    .text-view-point{
        padding-left: 20px;
        font-size: 22pt;
        color: #d2570a;
        font-family: Arial;
    }
    
    .text-view-detail {       
        text-align: right;
        width: 100%;
        padding-right: 70px;
        button {
            font-size: 12pt;
            color: blue;
            font-family: Arial;
            text-decoration: underline;
            border: none;
            background: none;
            font-weight: 700;
        }
    }
}
.card-info {
    height: 100%;
    border-radius: 40px;
    padding: 16px;
    box-shadow: 13px 15px 15px -15px #000000;
    background-repeat: no-repeat;
    min-height: 240px;
    display: flex;
    align-items: center;
    background-size: cover;

    .card-info_content {
        align-self: center;
        width: 100%;
        position: relative;
        top: 22%;
        font-weight: 700;
    }
    .card-info_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .card-info_item span {
        width: 57%;
        padding: 4px;
        border-bottom: 1px solid;
        font-size: 16px;
        &:first-child {
            width: 40%;
            text-align: right;
        }
    }
}
.gif-store_wrapper {
    margin-top: 85px;
    border-radius: 32px;
    border: 1px solid #ddd;
    background: rgb(247, 247, 247);
    padding: 20px;
    .botton-store-btn {
        position: relative;
        top: -20px;
        z-index: 999;
        width: 129px;
        height: 162px;
        border: none;
        height: 114px;
        width: 195px;
        cursor: pointer;
    }
    .loyalty-item-store {
        background: #fff;
        box-shadow: rgb(0, 0, 0) 10px 15px 15px -15px;
        border-radius: 30px;
        border: 1px solid #f3f2f2;
        padding: 10px;
        .div-img-border {
            cursor: pointer;
            min-height: 300px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            .img-auto-response {
                height: auto;
                width: auto;
                max-width: 500px;
                max-height: 300px;
                margin: auto;
            }
        }
        .info-gif {
            padding: 10px 20px;
            p {
                margin-bottom: 0;
            }
            a {
                color: #333;
            }
        }
    }
}
`